'use client'
import Header from "../Header";
import SingleListing from "../SingleListing";
import Reviews from "../Reviews";
import TextImageContainer from "../TextImageContainer"
import PricingGrid from "../Landlords/Pricing/PricingGrid";
import Link from "next/link";
import ContactForm from '../ContactForm';
import Background from '../background';
import {
    reviews
} from "./data";
import styles from '../sales.module.css';

const fileType = process.env.NEXT_PUBLIC_STRIPE_LIVE ? 'production' : 'development';

const pricing = require(`../../../../data/pricing/pricing-${fileType}.json`);

const AgentsPage = ({ user }) => (
    <>
        <Header active={'agent'} pageTitle={'Agents'} />
        <Background circles={
            [
                { x: 1100, y: 10, type: 'small', side: 'right' },
                { x: 130, y: -40, type: 'large', side: 'right' },
                { x: 100, y: 650, type: 'medium', side: 'left' },
                { x: 140, y: 1800, type: 'medium', side: 'left' },
                { x: 140, y: 1470, type: 'medium', side: 'right' },
                { x: 200, y: 2450, type: 'medium', side: 'right' },
                { x: 250, y: 3050, type: 'large', side: 'left' },
                { x: 980, y: 3380, type: 'small', side: 'right' },
                { x: 180, y: 4100, type: 'medium', side: 'right' },
                { x: 150, y: 4810, type: 'large', side: 'left' },
            ]}
            mobileCircles={
                [
                    { x: 0, y: 300, type: 'small', side: 'right' },
                    { x: 200, y: 1000, type: 'small', side: 'right' },
                    { x: 240, y: 1550, type: 'medium', side: 'left' },
                    { x: -80, y: 2450, type: 'medium', side: 'left' },
                    { x: 100, y: 4390, type: 'medium', side: 'right' },
                ]
            } zIndex={-1}
        />
        <div className={styles.AgentContainer} id='agentContainer'>
            <div className={styles.whyCompletely}>
                <h1>Why Completely Retail</h1>
                <p>Completely Retail is the UK’s leading retail property platform. We are focussed on connecting people actively seeking retail and leisure space with agents and landlords.</p>
            </div>

            <TextImageContainer link="#contactForm" img="trusted-by-professionals.jpg" greyContainer={false} id="TrustedProfessionals" title="Trusted by industry professionals" content="Join a thriving community of industry professionals who have discovered the power of our platform in connecting with the right tenants. With years of industry expertise, Completely Retail has become a trusted name in the world of retail property marketing." />

            <TextImageContainer link="#zcontactForm" img="Agent_shops_to_let.png" greyContainer={true} id="UnrivalledReach" title="Unrivalled reach" content="We provide a user-friendly, mobile first property marketing platform making it easy for occupiers to find their perfect space and providing you with qualified leads." />

            <TextImageContainer link="#contactForm" img="shutterstock_2138946871.jpg" greyContainer={false} id="EasyConnection" title="Easy connection" content="As the highest ranking website for retail and leisure space, Completely Retail provides unmatched exposure and quality leads for retail and leisure property. Reach 1000s of prospective tenants every month, eagerly searching for their next space." />

            <TextImageContainer link="#contactForm" img="showcase.png" greyContainer={true} id="PropertyPorential" title="Showcase your property's potential" content="Our intuitive listing tools empower you to showcase your property's unique selling points through high-quality images, detailed descriptions, and interactive floor plans." />

            <TextImageContainer link="#contactForm" img="dataManagement.png" greyContainer={false} id="DataManagement" title="Data management made easy" content="Our website integration ensures that your visitors receive up-to-date and reliable information on your properties, no matter where you’re advertising." />

            <Reviews reviews={reviews} />


            <h2 id="pricing" style={{scrollMarginTop: '150px'}} className={styles.marginTop}>Connecting you to new occupiers</h2>
            <SingleListing abovePrice={true} price="£150pa*" title="Single listing" content="Advertise a single property on our platform for up to 12 months. <br>
             *Price excludes VAT" includeButton={true} />


            <PricingGrid pricing={pricing} landlord={false} />

            <div className={styles.Bespoke}>
                <div className={styles.PricingHeader}>
                    Bespoke
                </div>
                <div className={styles.divider} />
                <p className={styles.content}>If you’re looking to advertise over 200 properties, or if our packages don’t suit your business, get in touch and we can discuss a bespoke package that fits your needs.</p>
                <button className={styles.contactButton}> <Link prefetch={false} href="#contactForm">Contact Us</Link></button>
            </div>



            <ContactForm reasons={
                [
                    'I’d like more information on the Starter Package',
                    'I’d like more information on the Basic Package',
                    'I’d like more information on the Standard Package',
                    'I’d like more information on the Premium Package',
                    'I’d like to find out more about Completely Retail',
                    'I have a technical problem',
                    'Other'
                ]
            } />


        </div>
    </>
);

export default AgentsPage;
